import AlertComponent from './inquiry';
import store from '@/stores'

const Inquiry = {}
// Vue暴露了一个install方法，用于自定义插件
Inquiry.install = function (Vue) {
  // 创建一个子类
  const AlertConstructor = Vue.extend(AlertComponent);
  // 实例化这个子类
  const instance = new AlertConstructor();
  // 创建一个div元素，并把实例挂载到div元素上
  instance.$mount(document.createElement('div'));
  // 将el插入到body元素中
  document.body.appendChild(instance.$el);

  // 添加实例方法
  Vue.prototype.$inquiry = () => {
    instance.display = true;
    instance.user_id = store.state.userId;
  };
}

export default Inquiry;